import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { TooltipWithErrorBoundary as Tooltip, TooltipConstants, removeClickable } from '@Components/Tooltip';
import { placeRightAlignBottom } from '@Pages/Heatmap/HeatmapTooltipHeaders/tooltipOverridePosition';
import { getOptionsTooltipContent } from '@Pages/Heatmap/HeatmapTooltipHeaders/getTooltipContent';
import { TooltipEvents } from './constants';

function HeatmapTooltipHeadersOptionsRows({ params, dataMap, type }) {
  const onClose = useCallback(() => {
    removeClickable(TooltipConstants.ids.HeatmapTooltipHeadersOptionsRows);
    TooltipEvents.hideOnClickTooltips();
  }, []);

  return (
    <Tooltip
      id={TooltipConstants.ids.HeatmapTooltipHeadersOptionsRows}
      elsTooltip={false}
      className="heatmap-tooltip rs-tooltip-big"
      place="right"
      overridePosition={placeRightAlignBottom}
      getContent={(index) => (index ? getOptionsTooltipContent({ params, data: dataMap[index], type, isRow: true, onClose }) : null)}
      hideDelay={100}
      globalEventOff={TooltipEvents.ON_CLICK_EVENT}
      clickable
      isCapture
      afterShow={TooltipEvents.hideOnHoverTooltips}
    />
  );
}

HeatmapTooltipHeadersOptionsRows.propTypes = {
  params: PropTypes.object.isRequired,
  dataMap: PropTypes.object,
  type: PropTypes.string,
};

export default HeatmapTooltipHeadersOptionsRows;
